import React, { useReducer } from 'react'
import CommentContext from './commentContext'
import CommentReducer from './commentReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_COMMENTS,
    GET_ALL_REPLY_COMMENTS,
} from './commentTypes'

const CommentState = (props) => {
    const initialState = {
        responseStatus: null,
        all_comments: {
            records: [],
            totalRecords: 0,
            from: '',
        },
        all_reply_comments: {
            records: [],
            totalRecords: 0,
            from: '',
        },
    }

    const [state, dispatch] = useReducer(CommentReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllComments = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllComments', formData, '', 'comment'),
            ])
            from = from ? from : 'getAllComments'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_COMMENTS,
                    payload: {
                        records: res.data.data.responseData?.records?.length
                            ? res.data.data.responseData?.records
                            : [],
                        totalRecords: res.data.data.responseData?.totalRecords,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getAllReplyComments = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'getAllReplyComments', formData, '', 'comment'),
            ])
            from = from ? from : 'getAllReplyComments'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_REPLY_COMMENTS,
                    payload: {
                        records: res.data.data.responseData?.records?.length
                            ? res.data.data.responseData?.records
                            : [],
                        totalRecords: res.data.data.responseData?.totalRecords,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const saveComment = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'saveComment'
            const [res] = await Promise.all([
                apiCall('post', 'saveComment', formData, '', 'comment'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <CommentContext.Provider
            value={{
                responseStatus: state.responseStatus,
                all_comments: state.all_comments,
                all_reply_comments: state.all_reply_comments,
                saveComment,
                getAllComments,
                getAllReplyComments,
                clearResponse,
            }}
        >
            {props.children}
        </CommentContext.Provider>
    )
}

export default CommentState
